/* @flow weak */
import BoxTitle from 'components/BoxTitle.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';
import ReactDOM from 'react-dom';
import TitleHeader from 'components/TitleHeader.jsx';
import ZopimOrSubmitTicketLink from 'support/components/ZopimOrSubmitTicketLink.jsx';
import { Roles } from 'user/UserConstants';

import cx from 'classnames';

const initialUploadView = (
  <div>
    <BoxTitle title="Upload a spreadsheet" />
    <div>
      <p>
        Create a spreadsheet (.csv only) for teachers, students or parents at your school. Each spreadsheet should include three columns: first name, last name,
        and email or mobile number.
        {' '}
        <Link
          href="http://assets.remind.com/schools/remind-upload-sample.csv"
          target="_blank"
          download>
          Download a sample template
        </Link>.
      </p>
      <div className="TeacherAddUploadTab-image">
        <Image
          className="TeacherAddUploadTab-spreadsheet-example"
          src={require('assets/images/spreadsheet-example.svg')}
        />
        <div className="TeacherAddUploadTab-overlay">
          <table>
            <tbody>
              <tr>
                <th>First name</th>
                <th>Last name</th>
                <th>Email or mobile number</th>
              </tr>
              <tr>
                <td>Natalie</td>
                <td>Koga</td>
                <td>nkoga@example.k12.us</td>
              </tr>
              <tr>
                <td>Max</td>
                <td>Rodriguez</td>
                <td>(555) 555-5555</td>
              </tr>
              <tr>
                <td>Farah</td>
                <td>Siddiqi</td>
                <td>fsiddiqi@example.k12.us</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

const errorUploadViewSubtext = (
  <div>
    Please make sure your spreadsheet is a CSV file (.csv) formatted to match
    {' '}
    <Link
      href="http://assets.remind.com/schools/remind-upload-sample.csv"
      target="_blank"
      download>
      our sample template
    </Link>.
    <br />
    If the problem continues, check out our
    {' '}
    <Link href={`${LinkConstants.ZENDESK}/articles/208218366`} target="_blank">FAQ</Link>
    {' '}
    or
    {' '}
    <ZopimOrSubmitTicketLink>
      contact us
    </ZopimOrSubmitTicketLink>.
  </div>
);

const errorUploadView = (
  <TitleHeader
    image={require('assets/images/spreadsheet-error.svg')}
    imageClassName="TeacherAddUploadTab-titleHeader-image"
    title="Couldn’t upload spreadsheet"
    subtext={errorUploadViewSubtext}
    bottomMargin="none"
  />
);

const TeacherAddUploadTabInitial = ({ dropzoneid, setRole, error }) => {
  const getUploadButton = (role) => {
    return (
      <Button
        className={cx(
          'upload_csv',
          `addFileButton_${dropzoneid}`,
        )}
        ref={(button) => {
          // The reason for adding an event listener instead of the onclick property
          // is that setting onclick overrides the dropzone functionality breaking
          // file uploads. By adding an event listener, it doesn't affect other handlers
          const node = ReactDOM.findDOMNode(button);
          if (node) {
            node.addEventListener('click', () => { setRole(role); });
          }
        }}
        level="secondary"
        size="medium">
        Upload {role}s
      </Button>
    );
  };

  const View = error ? errorUploadView : initialUploadView;
  return (
    <div>
      <div className="TeacherAddUploadTab-container">
        {View}
      </div>
      <Buttons className="TeacherAddUploadTab-attach">
        {getUploadButton(Roles.teacher)}
        {getUploadButton(Roles.parent)}
        {getUploadButton(Roles.student)}
      </Buttons>
    </div>
  );
};

TeacherAddUploadTabInitial.propTypes = {
  dropzoneid: React.PropTypes.number,
  setRole: React.PropTypes.func,
  error: React.PropTypes.string,
};

export default TeacherAddUploadTabInitial;



// WEBPACK FOOTER //
// ./src/groups/components/TeacherAddUploadTabInitial.jsx